export default function splitOnCaps (input: string) {
  if (!input) return
  const matchingString = input.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g)
  if (!matchingString) return input
  return matchingString.join(' ')
}
